export default function () {
    let map;
    const location = {lat: 54.2917984, lng: 18.412339};

    async function initMap() {
        // Request libraries when needed, not in the script tag.
        const {Map} = await google.maps.importLibrary('maps');
        // Short namespaces can be used.
        map = new Map(document.getElementById('map'), {
            center: location,
            zoom: 8
        });

        new google.maps.Marker({
            position: location,
            map: map
        });
    }

    initMap().then();
}

